import { getYMDAndTimeFormatDate } from 'utils/getCustomFormatDate';
import { fnComparedValueAndCriterion } from 'utils/logProcessing';

export default function makeDataLevel(d, gasCriterion, pageIndex, pageSize, index) {
  return {
    rnum: pageIndex * pageSize + index + 1,
    modelNm: d.module.modelNm,
    areaNo: d.module.areaNo,
    areaNm: d.module.areaNm,
    h2s: d.h2s,
    press: d.press,
    seqnum: d.seqnum,
    rssi: d.rssi,
    sf: d.sf,
    freqeuncy: d.freqeuncy,
    snr: d.snr,
    statusCode: d.statusCode,
    status: fnComparedValueAndCriterion(d, d.module.moduleScn, gasCriterion)[0],
    battery: d.battery,
    regTime: getYMDAndTimeFormatDate(new Date(d.rgstDt)),
  };
}
